<div class="search-results">
  <div class="search-results__input-wrap" [class.search-results__input-wrap--open]="open()">
    <span class="search-results__icon-left" aria-hidden="true">
      <!-- Search Icon -->
      <dsy-icon name="search" library="material" size="1rem"></dsy-icon>
      <!-- <svg viewBox="0 0 24 24" width="22" height="22" focusable="false">
        <path d="M15.5 14h-.79l-.28-.27a6.2 6.2 0 1 0-.71.71l.27.28v.79L20 20.5 21.5 19l-6-5zM10 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
      </svg> -->
    </span>

    <input
      #inputRef
      class="search-results__input"
      name="search"
      type="text"
      [formControl]="ctrl"
      autocomplete="off"
      spellcheck="false"
      placeholder="{{ 'FLEX_HOME.COMMON.SEARCH' | translate }}"
    />

    <!-- Spinner Loading / Clear btn -->
    <span class="search-results__right-slot">
      @if (loading()) {
        <span class="search-results__spinner" aria-hidden="true"></span>
      } @else if (ctrl.value.trim().length > 0) {
        <button
          type="button"
          class="search-results__btn-clear"
          (click)="onClear()"
          [attr.aria-label]="'FLEX_HOME.SEARCH_RESULTS_WIDGET.BUTTONS.CLEAR' | translate"
        >
          <dsy-icon name="close" library="material" size="1rem"></dsy-icon>
        </button>
      }
    </span>
  </div>

  <!-- Dropdown with results -->
  @if (open() && !loading()) {
    <div class="search-results__panel">
      @if (results().length > 0) {
        @for (item of results(); track item.id; let i = $index) {
          <button class="search-results__option" type="button" [class.search-results__option--active]="i === activeIndex()" (mouseenter)="onHover(i)" (click)="select(item)">
            {{ item.label }}
          </button>
        }
      } @else if (showNoResults()) {
        <div class="search-results__empty">
          {{ 'FLEX_HOME.COMMON.NO_DATA' | translate }}
        </div>
      }
    </div>
  }
</div>
